export function resolveColumnInsertionPlacement(targetRect, pointerX) {
  if (!targetRect) {
    return null;
  }
  if (pointerX === null || pointerX === undefined) {
    return null;
  }

  const targetLeft = Number(targetRect.left);
  const targetWidth = Number(targetRect.width);
  const targetRight = Number.isFinite(Number(targetRect.right))
    ? Number(targetRect.right)
    : targetLeft + targetWidth;
  const resolvedPointerX = Number(pointerX);

  if (!Number.isFinite(targetLeft) || !Number.isFinite(targetRight) || !Number.isFinite(resolvedPointerX)) {
    return null;
  }

  const midpoint = targetLeft + ((targetRight - targetLeft) / 2);
  return resolvedPointerX < midpoint ? "before" : "after";
}

/**
 * Détermine de quel côté de la colonne cible afficher la ligne d'insertion.
 * Quand le pointeur est connu, la moitié gauche/droite de la cible décide.
 * Sans pointeur, on conserve le comportement historique basé sur la source.
 */
export function resolveColumnInsertionLineSide(sourceRect, targetRect, pointerX = null) {
  if (!sourceRect || !targetRect) {
    return null;
  }
  if (sourceRect.left === targetRect.left && sourceRect.width === targetRect.width) {
    return null;
  }

  const placement = resolveColumnInsertionPlacement(targetRect, pointerX);
  if (placement === "before") {
    return "left";
  }
  if (placement === "after") {
    return "right";
  }

  return sourceRect.left < targetRect.left ? "left" : "right";
}

export function resolveColumnInsertionLineRect(sourceRect, targetRect, pointerX = null) {
  const side = resolveColumnInsertionLineSide(sourceRect, targetRect, pointerX);
  if (!side) {
    return null;
  }

  const targetRight = Number.isFinite(targetRect.right)
    ? targetRect.right
    : targetRect.left + targetRect.width;

  return {
    height: targetRect.height,
    left: side === "left" ? targetRect.left : targetRight,
    top: targetRect.top,
  };
}
